<div class="ai-search-bar">
  <div class="ai-search-bar-input">
    <kendo-textbox
      [value]="searchTerm()"
      (valueChange)="onSearchTermChange($event)"
      (keyup)="onKeyUp($event)"
      [placeholder]="placeholder"
      [clearButton]="true"
      class="ai-search-textbox">
      <ng-template kendoTextBoxSuffixTemplate>
        <button class="ai-search-button" (click)="onSearch()" title="Search">
          <kendo-svg-icon [icon]="searchIcon"></kendo-svg-icon>
        </button>
      </ng-template>
    </kendo-textbox>
  </div>
</div>
